var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRabbyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "52 25 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000161597173617360504640000012432366591255278478_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000021803777515098205300000017382971856690286485_);}\n\t.st3{fill:url(#SVGID_00000031192219548086493050000012287181694732331425_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.6827,
    y1: 79.8441,
    x2: 148.229,
    y2: 61.2564,
    gradientTransform: "matrix(1 0 0 -1 0 154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8797FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAA8FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.9,81.9c3.7-8.3-14.7-31.6-32.3-41.2c-11.1-7.5-22.6-6.5-25-3.2c-5.1,7.2,17,13.4,31.8,20.5  c-3.2,1.4-6.2,3.9-7.9,7c-5.5-6-17.6-11.2-31.8-7c-9.6,2.8-17.5,9.5-20.6,19.5c-0.7-0.3-1.6-0.5-2.4-0.5c-3.3,0-6,2.7-6,6  c0,3.3,2.7,6,6,6c0.6,0,2.5-0.4,2.5-0.4L94,88.8c-12.3,19.6-22.1,22.4-22.1,25.8c0,3.4,9.3,2.5,12.8,1.2c16.8-6,34.8-24.9,37.9-30.3  C135.6,87.2,146.5,87.3,148.9,81.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044169200580553624300000013345904656810082952_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.7581,
    y1: 78.3765,
    x2: 87.4635,
    y2: 125.7869,
    gradientTransform: "matrix(1 0 0 -1 0 154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B22A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5156D8",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000044169200580553624300000013345904656810082952_)"
    },
    d: "  M123.5,58C123.5,58,123.5,58,123.5,58c0.7-0.3,0.6-1.3,0.4-2.1c-0.4-1.8-7.9-9.2-14.9-12.5c-9.6-4.5-16.6-4.3-17.6-2.2  c1.9,4,11,7.7,20.4,11.7C115.7,54.5,119.8,56.2,123.5,58C123.5,58,123.5,58,123.5,58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011711276424470013000000013596413199536411566_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.605,
    y1: 54.0865,
    x2: 67.1733,
    y2: 80.2065,
    gradientTransform: "matrix(1 0 0 -1 0 154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B1E8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A6FFB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000011711276424470013000000013596413199536411566_)"
    },
    d: "  M111.3,98.2c-1.9-0.7-4.1-1.4-6.6-2c2.6-4.7,3.2-11.8,0.7-16.2c-3.5-6.2-7.9-9.5-18.2-9.5c-5.6,0-20.8,1.9-21.1,14.6  c0,1.3,0,2.5,0.1,3.7L94,88.8c-3.7,5.9-7.2,10.3-10.3,13.6c3.7,0.9,6.7,1.7,9.5,2.5c2.6,0.7,5.1,1.3,7.6,2  C104.6,104.1,108.2,101.1,111.3,98.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132774675072191537280000013935395272828303517_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5164,
    y1: 74.4534,
    x2: 110.2249,
    y2: 35.435,
    gradientTransform: "matrix(1 0 0 -1 0 154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8898FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    style: {
      stopColor: "#5F47F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132774675072191537280000013935395272828303517_)"
    },
    d: "M62.7,87.3c1.1,9.6,6.6,13.4,17.8,14.5  c11.2,1.1,17.6,0.4,26.1,1.1c7.1,0.6,13.5,4.3,15.8,3c2.1-1.1,0.9-5.2-1.9-7.8c-3.7-3.4-8.8-5.7-17.7-6.6c1.8-4.9,1.3-11.8-1.5-15.5  c-4-5.4-11.4-7.8-20.8-6.8C70.7,70.4,61.3,75.3,62.7,87.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbyLogo);
export default __webpack_public_path__ + "static/media/rabby-logo.0cb93ffcc335ea6d2ab2900f1d4683ca.svg";
export { ForwardRef as ReactComponent };